import styled from 'styled-components';
import APPBG from '../images/appudvikling_baggrund.png';

export const AppUdviklingPage = styled.div`
  background-image: url(${APPBG});
  background-repeat: no-repeat;
  background-position: 80% 0%;
  background-attachment: scroll;
`;
